import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import {injectIntl} from "react-intl";

import { modifyPageLayoutComponents } from '../PageLayout';
import template from './Customers.rt';
import CustomerHeader from './CustomerHeader';
import { getCustomers, changeCustomerStatus } from '../../actions/customers';
import { logout } from '../../actions';
import {AccessRights} from '../../schemas/accessRightsModel';

const mapStateToProps = state => ({
  searchKeyword: state.customers.searchKeyword,
  customers: state.customers.data.rows,
  page: state.customers.data.page,
  totalPages: state.customers.data.totalPages,
  statusUpdateSuccess: state.customers.statusUpdateSuccess,
  AR: AccessRights.get(state)
});

const mapDispatchToProps = dispatch => ({
  getCustomers: (page, limit, searchKeyword) => dispatch(getCustomers(page, limit, searchKeyword)),
  changeCustomerStatus: (customerId, enabled) => dispatch(changeCustomerStatus(customerId, enabled)),
  setSearchTerm: (value) => dispatch(getCustomers(0, 50, value)),
  logout: () => dispatch(logout())
});

class Customers extends Component {
  constructor(props) {
    super(props);

    const dropdownValues = ['Fabricators'];
    const {AR} = this.props;
    if (AR.isSiteAdmin()) {
      dropdownValues.push('Employees');
      dropdownValues.push('Stores');
    }

    this.state = {
      page: 0,
      isDropDownOpened: false,
      activeDropDownValue: 'Customers',
      dropdownValues
    }
  }

  componentWillMount() {
    this.props.getCustomers(this.state.page, 50, this.props.searchKeyword || '');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statusUpdateSuccess) {
      this.props.getCustomers(this.state.page, 50, this.props.searchKeyword || '');
    }
  }

  handleActivateUser = (customerId, enabled) => {
    this.props.changeCustomerStatus(customerId, !enabled);
  }

  handleAddCustomer = () => {
    console.log('add')
  }

  handleEditCustomer = () => {
    console.log('edit')
  }

  handlePaginate = (page) => {
    this.setState({page: page - 1});
    this.props.getCustomers(page - 1, 50, this.props.searchKeyword);
  }

  handleRedirect = (entityId, clientType, clientSubType) => {
    let redirectUrl = 'account'
    if (entityId) {
      redirectUrl += `?entityId=${entityId}&clientType=Client`
    }
    if (!entityId) {
      redirectUrl += `?clientType=${clientType}&clientSubType=${clientSubType}`
    }
    hashHistory.push(redirectUrl)
  }

  handleDropDownChange = (value) => {
    this.setState({isDropDownOpened: !this.state.isDropDownOpened});

    if (value) {
      hashHistory.push(value.toLowerCase());
    }
  }

  render() {
    return template.apply(this);
  }
}

Customers.propTypes = {
  customers: PropTypes.array,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  success: PropTypes.bool,
  getCustomers: PropTypes.func.isRequired,
  changeCustomerStatus: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const CustomersLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(CustomerHeader),
  content: injectIntl(connector(Customers))
});

